import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
  Button,
} from '@mui/material';
import {
  Language as LanguageIcon,
  Logout,
  Upload as UploadIcon,
  CameraAlt as CameraIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../components/LanguageSelector';
import CsvUpload from '../components/CsvUpload';
// import CalibrationCapture from '../components/CalibrationCapture';
import { WithDeviceProps } from '../hooks/withDevice';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const TOTAL_IMAGES = 20;

const Settings: React.FC<WithDeviceProps> = ({ isMobileDevice }) => {
  const { t } = useTranslation();
  const [error, setError] = useState<string>('');
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
      <Box sx={{ 
        maxWidth: isMobileDevice ? '100%' : 600, 
        mx: 'auto', 
        p: 2,
        pb: isMobileDevice ? 8 : 2,
        pt: 3
      }}>
        {/* Alerts */}
        {error && (
          <Alert 
            severity="error" 
            sx={{ 
              mb: 2,
              borderRadius: '0px !important',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            {error}
          </Alert>
        )}

        {/* Language Settings Card */}
        <Card 
          sx={{ 
            mb: 3,
            borderRadius: 3,
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid rgba(0,0,0,0.05)',
          }}
        >
          <CardContent sx={{ p: isMobileDevice ? 2 : 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <LanguageIcon color="primary" />
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 600,
                  color: 'primary.main',
                }}
              >
                {t('settings.languageSettings')}
              </Typography>
            </Box>
            
            <Typography 
              variant="body2" 
              color="text.secondary" 
              sx={{ mb: 3, lineHeight: 1.6 }}
            >
              {t('settings.languageDescription')}
            </Typography>

            <Box>
              <LanguageSelector />
            </Box>
          </CardContent>
        </Card>

        {/* Calibration Card - Mobile Only */}
        {/* {isMobileDevice && (
          <Card 
            sx={{ 
              mb: 3,
              borderRadius: 3,
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              border: '1px solid rgba(0,0,0,0.05)',
            }}
          >
            <CardContent sx={{ p: isMobileDevice ? 2 : 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <CameraIcon color="primary" />
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 600,
                    color: 'primary.main',
                  }}
                >
                  {t('settings.calibration.title')}
                </Typography>
              </Box>
              
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ mb: 3, lineHeight: 1.6 }}
              >
                {t('settings.calibration.description', { total: TOTAL_IMAGES })}
              </Typography>

              <CalibrationCapture totalImages={TOTAL_IMAGES} />
            </CardContent>
          </Card>
        )} */}

        {/* CSV Upload Card */}
        {!isMobileDevice && (
          <Card 
            sx={{ 
              mb: 3,
              borderRadius: 3,
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              border: '1px solid rgba(0,0,0,0.05)',
            }}
          >
            <CardContent sx={{ p: isMobileDevice ? 2 : 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <UploadIcon color="primary" />
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 600,
                    color: 'primary.main',
                  }}
                >
                  {t('settings.csvUpload.title')}
                </Typography>
              </Box>
              
              <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ mb: 3, lineHeight: 1.6 }}
              >
                {t('settings.csvUpload.description')}
              </Typography>

              <CsvUpload 
                onUploadSuccess={() => {
                  // Handle successful upload if needed
                }}
                onUploadError={(error) => {
                  setError(error);
                }}
              />
            </CardContent>
          </Card>
        )}

        <Button startIcon={<Logout />} variant="contained" fullWidth color="primary" onClick={() => {
          logout();
          navigate('/login');
        }}>
          {t('settings.logout')}
        </Button>
      </Box>
  );
};

export default Settings; 